
import React from "react";
import { FormControls, i18nManager } from "../../../../../i18n";
import { BaseService, IPlatform, PipelineService, SanitizedResponse } from "../../../../../services";
import { Chart, ChartData, ChartType, Classname, DateHelper, useSearchParams } from "@rivtn/noseur";
import { Utils } from "../../../../../utils";
import { Elements } from "../../../../shared";

export interface LeadAnalyticsProps {
    platform: IPlatform;
}

function LeadAnalytics(props: LeadAnalyticsProps) {

    const pipelineService = PipelineService.getInstance();
    const [earningsChartData, setEarningsChartData] = React.useState<ChartData>();
    const leadLabels = i18nManager.Labels.dashboard.platform_management.crm.pipeline.leads;
    const labels = i18nManager.Labels.dashboard.platform_management.crm.pipeline.lead_anals;
    const { searchParams, setSearchParams, status, setStatus, ctype, setCtype } = useSearchParams({
        defaultInit: window.location.search,
        params: {
            status: "",
            ctype: "count"
        }
    });

    React.useEffect(() => {
        fetchLeadAnals();
    }, [searchParams]);

    return (<div className="lead-anals">
        <span className="title">{labels.title}</span>
        <span className="desc">{labels.desc}</span>
        <hr />
        <div className="filters">
            <div className="filters">
                {labels.filters.form?.map((control: FormControls, index: number) => {
                    return (<div key={index} className="filter">
                        <span>{control.title}</span>
                        {Elements.buildConfirmDialogForm([control], (name, value) => {
                            
                        }, searchParams, undefined, { marginTop: 0 }, undefined, { marginTop: 7 }, setSearchParams, undefined, undefined, { platform_id: "messages_platform_id" })}
                    </div>);
                })}
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="leads-tags">
                    <i className="fa fa-bar-chart" />
                    {leadLabels.statuses.map((s) => (<div key={s.value} className={Classname.build("noseur-pill", { active: s.value === status })} onClick={() => setStatus(s.value)}>{s.label}</div>))}
                </div>
                <span className="link" onClick={() => setCtype(ctype === "count" ? "monetary" : "count")}>{ctype === "count" ? labels.switch_monetary : labels.switch_count}</span>
            </div>
        </div>
        <hr />
        <Chart className="curs-ears-chart" type={ChartType.LINE} options={{ maintainAspectRatio: false }} data={earningsChartData} />
    </div>);

    function fetchLeadAnals() { // ;)
        setEarningsChartData(undefined);
        pipelineService.queryCrmLeadsAnalytics({
            status,
            to: searchParams.get("to") ?? Utils.formatToApiDate(new Date(), false, false)!,
            from: searchParams.get("from") ?? Utils.formatToApiDate(DateHelper.getStartOfMonth(), false, false)!,
        }, ctype === "monetary").then(({ apiResponse }: SanitizedResponse<any>) => {
            setEarningsChartData(apiResponse.data!);
        }).catch(BaseService.reportError);
    }

}

export default LeadAnalytics;
